var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.value,
          expression: "value",
        },
      ],
      staticStyle: {
        position: "absolute",
        transition: "all 0.5s",
        width: "0px",
      },
    },
    [
      _c("div", { staticClass: "ice-drawer-mask" }),
      _c(
        "div",
        { staticClass: "ice-drawer-wrap", on: { click: _vm.maskClick } },
        [
          _c(
            "div",
            {
              staticClass: "ice-drawer",
              style: { width: _vm.width + "px" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.stop($event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "ice-drawer-content" },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }